import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CheckCircle2, Loader2, Copy } from "lucide-react";

export function Field({ label, required, children }) {
  return <div className="space-y-1.5"><Label>{label}{required && <span className="text-primary"> *</span>}</Label>{children}</div>;
}

export function Success({ refNo, title = "Thank you!", message }) {
  return (
    <div className="rounded-2xl border border-success/30 bg-success/5 p-8 text-center" data-testid="form-success">
      <div className="w-14 h-14 rounded-full bg-success/15 flex items-center justify-center mx-auto"><CheckCircle2 className="w-8 h-8 text-success" /></div>
      <h3 className="font-heading text-2xl font-bold mt-4">{title}</h3>
      <p className="text-muted-foreground mt-2">{message}</p>
      {refNo && (
        <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-card border border-border px-5 py-2.5">
          <span className="text-sm text-muted-foreground">Reference</span>
          <span className="font-heading font-bold" data-testid="reference-number">{refNo}</span>
          <button onClick={() => { navigator.clipboard?.writeText(refNo); toast.success("Copied"); }} className="text-muted-foreground hover:text-primary"><Copy className="w-4 h-4" /></button>
        </div>
      )}
      <p className="text-xs text-muted-foreground mt-6">This is a demo submission — a record has been created in the LFM Operations OS CRM.</p>
    </div>
  );
}

export function useSubmit() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const submit = async (fn) => {
    setLoading(true);
    try { const data = await fn(); setResult(data); return data; }
    catch (e) { toast.error(apiError(e)); throw e; }
    finally { setLoading(false); }
  };
  return { loading, result, submit, setResult };
}

export { api, toast, Input, Textarea, Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Loader2 };
